import { useEffect, useState } from 'react';
import api from '../../axiosConfig';
import { useNotification } from './NotificationProvider';

export default function ConsultaComponente() {
    const [usuario, setUsuario] = useState(null);
    const [noEmpleado, setNoEmpleado] = useState(0);

    const [anios, setAnios] = useState([]);
    const [anioSeleccionado, setAnioSeleccionado] = useState('');
    const [declaracionNeto, setDeclaracionNeto] = useState(null);

    const { notify } = useNotification();

    const getUsuarioLocalStorage = async ()  => {
        try {
            const useruserStorage = await localStorage.getItem('userObj');
            console.log(useruserStorage)
            if (!useruserStorage) {
                setUsuario(null);
                setNoEmpleado(0);
                return;
            }

            const user = JSON.parse(useruserStorage);

            setUsuario(user);
            setNoEmpleado(user?.noEmpleado || 0);
        } catch (err) {
            console.error('Error al leer user del localStorage:', err);
            setUsuario(null);
            setNoEmpleado(0);
            notify('No fue posible obtener la información del usuario en sesión.', 'error');
        }
    };

    const getAniosByNoEmpleado = async (numeroEmpleado) => {
        try {
            if (!numeroEmpleado || Number(numeroEmpleado) <= 0) {
                setAnios([]);
                setAnioSeleccionado('');
                setDeclaracionNeto(null);
                return;
            }

            const res = await api.get(`/Sync/declaracion/admin/grupo/${numeroEmpleado}`);

            let aniosParseados = [];

            if (res.data?.obj) {
                try {
                    const parsed = JSON.parse(res.data.obj);
                    aniosParseados = Array.isArray(parsed) ? parsed : [];
                } catch (parseError) {
                    console.error('Error al parsear años:', parseError);
                    notify('No fue posible interpretar los años devueltos por el servicio.', 'error');
                }
            }

            setAnios(aniosParseados);
            setAnioSeleccionado('');
            setDeclaracionNeto(null);
        } catch (err) {
            console.error('Error al obtener años:', err);
            setAnios([]);
            setAnioSeleccionado('');
            setDeclaracionNeto(null);
            notify('Ocurrió un error al consultar los años: ' + err.message, 'error');
        }
    };

    const getDeclaracionNeto = async (numeroEmpleado, anio) => {
        try {
            if (!numeroEmpleado || !anio) {
                setDeclaracionNeto(null);
                return;
            }

            const res = await api.get(`/Sync/declaracion/admin/neto/${numeroEmpleado}/${anio}`);

            let declaracionParseada = null;

            if (res.data?.obj) {
                try {
                    declaracionParseada = JSON.parse(res.data.obj);
                } catch (parseError) {
                    console.error('Error al parsear declaración neto:', parseError);
                    notify('No fue posible interpretar la declaración del servicio.', 'error');
                }
            }

            setDeclaracionNeto(declaracionParseada);
        } catch (err) {
            console.error('Error al obtener neto:', err);
            setDeclaracionNeto(null);
            notify('Ocurrió un error al consultar la declaración: ' + err.message, 'error');
        }
    };

    const formateaMoneda = (valor) => {
    if (valor === null || valor === undefined || valor === '') return '';

    const numero = Number(valor);

    if (isNaN(numero)) return '';

    return `$ ${numero.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
};

const formateaFecha = (fecha) => {
    if (!fecha) return '';

    const partes = fecha.split('-'); // [yyyy, mm, dd]

    if (partes.length !== 3) return fecha;

    const [anio, mes, dia] = partes;

    return `${dia}/${mes}/${anio}`;
};

    useEffect(() => {
        getUsuarioLocalStorage();
    }, []);

    useEffect(() => {
        getAniosByNoEmpleado(noEmpleado);
    }, [noEmpleado]);

    useEffect(() => {
        if (noEmpleado && anioSeleccionado) {
            getDeclaracionNeto(noEmpleado, anioSeleccionado);
        } else {
            setDeclaracionNeto(null);
        }
    }, [noEmpleado, anioSeleccionado]);

    return (
        <>
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header">
                        <h5 className="card-title mb-0">Consulta de declaración</h5>
                    </div>
                    <div className="card-body">
                        <form className="row gy-3" noValidate>
                            <div className="col-md-6">
                                <label className="form-label">No. empleado</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={usuario?.noEmpleado ?? ''}
                                    disabled
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">RFC</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={usuario?.rfc ?? ''}
                                    disabled
                                />
                            </div>

                             

                            <div className="col-md-4">
                                <label className="form-label">Años</label>
                                <select
                                    className="form-select"
                                    value={anioSeleccionado}
                                    onChange={(e) => setAnioSeleccionado(e.target.value)}
                                    disabled={!noEmpleado || anios.length === 0}
                                >
                                    <option value="">Seleccione un año</option>
                                    {anios.map((item, index) => (
                                        <option key={`${item.anio}-${index}`} value={item.anio}>
                                            {item.anio}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {declaracionNeto && (
                <div className="col-lg-12 mt-3">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Declaración anual</h5>
                        </div>
                        <div className="card-body">
                            <div className="row gy-3">
                                <div className="col-md-3">
                                    <label className="form-label">Año</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.anio ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">Tipo nómina</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.tipoNomina ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">No. empleado</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.noEmpleado ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">Fecha ingreso</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formateaFecha( declaracionNeto.fechaIngreso ?? '')}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Nombre</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.nombre ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">RFC</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.rfc ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">CURP</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={declaracionNeto.curp ?? ''}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Percepciones</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formateaMoneda(declaracionNeto.percepciones)}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">ISR</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formateaMoneda(declaracionNeto.isr)}
                                        disabled
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Neto</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={formateaMoneda(declaracionNeto.neto)}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}